import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../../context/AudioContext';
import { fetchMostFavoriteChannels } from '../../services/ChannelService';
import { Link } from 'react-router-dom';

const MostFavoriteChannels = () => {
    const [history, setHistory] = useState([]);
    const { setCurrentChannel } = useContext(AudioContext);
    const [favoriteChannels, setMostFavoriteChannels] = useState([]);

    useEffect(() => {
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }

        const loadMostFavoriteChannels = async () => {
            try {
                const data = await fetchMostFavoriteChannels(); // Use the API function
                setMostFavoriteChannels(data);
            } catch (error) {
                console.error('Error loading Radio channels:', error);
            }
        };

        loadMostFavoriteChannels();

    }, []);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length) updatedHistory.pop(); // Limit history to 5 items

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>Most Favorite Channels</h2>
                        </div>
                    </div>

                    {favoriteChannels.length === 0 ? (
                        <div className="col-12">
                            <p>No channels found.</p>
                        </div>
                    ) : (
                        favoriteChannels.map((channel) => (
                            <div className="col-3 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover" key={channel.id} onClick={() => playChannel(channel)}>
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <Link role='button' onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title">
                                        <h3><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                        <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MostFavoriteChannels;
